<template>
  <div class="div-container">

    <a href="javascript:void(0)" rel="external nofollow" @click="goMovieDetail">

      <el-card :body-style="{ padding: '0px' ,borderRadius:'20px'}">

        <div class="div-image-container">

          <el-image style="width: 100%; height: 100%" :src="cover_image" fit="cover">
          </el-image>

        </div>

        <div class="div-info-container">

          {{data.department_name}}

        </div>

      </el-card>

    </a>

  </div>
</template>

<script>
import Common from '../../../../js/Common'

export default {
  name: 'MovieDepartmentItem',
  props: {
    data: Object
  },
  data () {
    return {
      cover_image: Common.getMovieCover(this.data.id)
    }
  },
  methods: {
    goMovieDetail () {
      this.$router.push({path: '/movie/department_info', name: 'MovieDepartmentInfo', query: {department_id: this.data.id}})
    }
  }
}
</script>

<style scoped>
.div-container{
  width:450px;
  height: 380px;
}

.div-image-container{
  /*width:450px;*/
  height:247px;
  background-color: #20a0ff;
}

.div-info-container{
  /*width:450px;*/
  height: 93px;
  padding: 20px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/movie/MovieDepartmentItem.vue